export var SHOPGATE_USER_RESET_PASSWORD='shopgate.user.resetPassword';